export default __webpack_public_path__ + "static/media/pexels-nathan-cowley-897817.e793d9ed.jpg";